/**
 * Created by Ray on 2017/10/18.
 */

import { Component } from '@angular/core';
import {AuthService} from "../shared/service/auth.service";
import { Router} from '@angular/router';
@Component({
    selector: 'svc-header',
    templateUrl: './header.component.html',
    styleUrls:['./header.component.css']
})
export class Header {
    profileDisplay: boolean;
    constructor(private auth: AuthService, private router:Router){
        this.profileDisplay = false;
    }

    logout(){
        this.auth.logout();
    }

    showProfile(){
        //this.globalService.changeStatus('profile-display', true);
        this.profileDisplay = true;
    }

    goHome(){
        const url = this.auth.getDefaultUrl();
        this.router.navigate([url]);
    }
}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/header/header.component.ts